/*
      Title: Action Type
      Description: Action Type
      Author: Iqbal Hossain
      Date: 05-January-2022
      Modified: 05-January-2022
*/

export const FETCH_SAMPLE_TYPE = 'FETCH_SAMPLE_TYPE';
export const TOGGLE_SAMPLE_TYPE_SIDEBAR = 'TOGGLE_SAMPLE_TYPE_SIDEBAR';
export const TOGGLE_SAMPLE_TYPE_STATUS = 'TOGGLE_SAMPLE_TYPE_STATUS';
export const FETCH_SAMPLE_TYPE_BY_QUERY = 'FETCH_SAMPLE_TYPE_BY_QUERY';
export const ADD_SAMPLE_TYPE = 'ADD_SAMPLE_TYPE';
export const DELETE_SAMPLE_TYPE = 'DELETE_SAMPLE_TYPE';
export const FETCH_SAMPLE_TYPE_BY_ID = 'FETCH_SAMPLE_TYPE_BY_ID';
export const UPDATE_SAMPLE_TYPE = 'UPDATE_SAMPLE_TYPE';
export const DELETE_SAMPLE_TYPE_BY_RANGE = 'DELETE_SAMPLE_TYPE_BY_RANGE';
